import { FC, ReactNode } from "react";
import { Toolbar } from "@mui/material";
import { useDense } from "shared-ts-ui-responsive";
import { useSxMergeStrict } from "shared-ts-mui";
import { SxProps } from "@mui/material";

export interface PageToolbarProps {
  className?: string;
  children: ReactNode;
  sx?: SxProps;
}
export const PageToolbar: FC<PageToolbarProps> = (props) => {
  const dense = useDense();
  const sx = useSxMergeStrict(
    () => [
      props.sx,
      {
        display: "flex",
        alignItems: "center",
        minHeight: dense ? "56px" : undefined,
        "> .MuiDivider-root": {
          ml: 1,
          mr: 0,
        },
        "> .MuiButton-root": {
          ml: 1,
        },
      },
    ],
    [dense, props.sx]
  );
  return (
    <Toolbar
      disableGutters
      variant={dense ? "dense" : "regular"}
      className={
        "PageToolbar" + (props.className != null ? " " + props.className : "")
      }
      sx={sx}
    >
      {props.children}
    </Toolbar>
  );
};
